import { RolesSettings } from "./RolesSettings";
import { CategoriesSettings } from "./CategoriesSettings";
import { DealStagesSettings } from "./DealStagesSettings";

const SECTIONS: { id: string; label: string }[] = [
  { id: "roles", label: "Roles" },
  { id: "deal-stages", label: "Deal Stages" },
  { id: "categories", label: "Categories" },
  { id: "project-defaults", label: "Project Defaults" },
];

function PlaceholderSection({ label }: { label: string }) {
  return (
    <section className="settings-section">
      <div className="settings-section__header">
        <h2 className="settings-section__title">{label}</h2>
      </div>
      <p className="app-settings__placeholder">{label} settings are coming soon.</p>
    </section>
  );
}

export function AppSettings() {
  return (
    <div className="app-settings">
      {SECTIONS.map((section) => {
        switch (section.id) {
          case "roles":
            return <RolesSettings key={section.id} />;
          case "categories":
            return <CategoriesSettings key={section.id} />;
          case "deal-stages":
            return <DealStagesSettings key={section.id} />;
          default:
            return <PlaceholderSection key={section.id} label={section.label} />;
        }
      })}
    </div>
  );
}
